module.exports = __webpack_public_path__ + "img/active.49c163a0.png";